import { switchMap } from 'rxjs/operators'
import Actions from '../actions'
import { getPayload } from '../utils/rxUtils'
import { of, map } from 'rxjs'
import { deserializeEnrolles } from 'utils/serializers/memberDeserializers'

export const addMemberId = action$ =>
  action$.pipe(
    getPayload(Actions.STEP_SAVED, Actions.APPLICATION_DATA_RECEIVED),
    map(({ data }) => data),
    map(deserializeEnrolles),
    switchMap(members =>
      of(Actions.createAction(Actions.MEMBERS_UPDATED, members))
    )
  )
